import { SyntheticEvent, useCallback } from "react"
import { Button, ButtonProps } from "@mezo-org/mezo-clay"

import { setOpenModal, useDappDispatch } from "#/redux-state"
import { usePosthogAddFundsEvent } from "#/shared/hooks/posthog-events"

type BridgeAssetButtonProps = ButtonProps & {
  depositId?: number
}

export default function BridgeAssetButton({
  children,
  onClick,
  depositId,
  ...props
}: BridgeAssetButtonProps) {
  const { emitAddFundsStartedEvent } = usePosthogAddFundsEvent()
  const dispatch = useDappDispatch()

  const handleClick = useCallback(
    (e: SyntheticEvent<HTMLButtonElement>) => {
      dispatch(setOpenModal("bridge-asset", { depositId }))
      emitAddFundsStartedEvent()
      onClick?.(e)
    },
    [dispatch, emitAddFundsStartedEvent, onClick, depositId],
  )

  return (
    <Button size="small" shape="pill" onClick={handleClick} {...props}>
      {children ?? "Add funds"}
    </Button>
  )
}
